
import { camelizeKeys } from '@zoocasa/node-kit/objects/transform-keys';
import endpoint from 'utils/endpoint';

export default class Neighbourhood {
  id: number;
  averageHouseholdIncome: number;
  averagePropertyPrice: number;
  ethnicities: {
    value: string;
    percentage: number;
  }[];
  ages: {
    value: string;
    percentage: number;
  }[];
  name: string;
  populationTotal: number;
  propertiesOwned: number;
  propertiesRented: number;
  propertiesTotal: number;

  constructor(neighbourhood: Record<string, unknown>) {
    const camelizedNeighbourhood = camelizeKeys(neighbourhood);
    const attributes = camelizedNeighbourhood.attributes as Record<string, unknown>;
    const relationships = camelizedNeighbourhood.relationships as Record<
      string,
      unknown
    >;
    const formattedNeighbourhood = {
      ...attributes,
      ...relationships,
      id: camelizedNeighbourhood.id,
    } as Neighbourhood;
    Object.assign(this, formattedNeighbourhood);
  }

  get propertiesOwnedPercent() {
    return Math.round(this.propertiesOwned / this.propertiesTotal * 100);
  }

  get propertiesRentedPercent() {
    return Math.round(this.propertiesRented / this.propertiesTotal * 100);
  }
}

export async function getNeighbourhoodDemographics(id: Neighbourhood['id'], signal?: AbortSignal) {
  const { data } = await endpoint<{ data: Record<string, unknown> }>(`/services/api/v3/neighbourhoods/${id}`, 'GET', undefined, undefined, signal);
  return data;
}
